var poll_default = {
  "fontElementMap": "o3mNm",
  "container": "uNRom",
  "fullscreen": "_7EM89",
  "background_overlay": "gp99O",
  "with_image": "_5BjqA",
  "options": "uHPll",
  "webview": "zU2LX",
  "grid": "Ihgpf",
  "option": "pK9Fi",
  "cta_button": "qP-ID",
  "add_option": "lLCgJ",
  "see_more": "LVPiV",
  "list": "GzEqs",
  "column": "suQ6V",
  "additional_note": "fFjje",
  "spinner": "kCMQI",
  "spin": "-TX-N",
  "shown": "MzI0g",
  "error": "QBUi6"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
